<template>

  <div id="document-top" v-if="application_status.loaded">
    
    <!-- 
      I don't know how or why but removing the invisible span element will stop the page from rendering 
      after loading another application 
    -->
    <span :data="application"></span>

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content" />
    <md-dialog-confirm
      :md-active.sync="confirm_dialog.show"
      :md-title="confirm_dialog.title"
      :md-content="confirm_dialog.content"
      md-confirm-text="YES"
      md-cancel-text="NO"
      @md-cancel="onCancel"
      @md-confirm="confirm_dialog.action" />
    <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
      <md-button class="md-primary md-simple md-dense" @click="snackbar.show = false">Dismiss</md-button>
      <md-button class="md-primary md-simple md-dense" @click="onGoToSummary">Go to summary</md-button>
    </md-snackbar>

    <scroll-tracker ref="scroll-tracker">
      <div class="md-layout">

        <div class="navigation">
          <div class="sticky-top">
            <h4>Progress</h4>
            <scroll-progress scroll-offset="-70"></scroll-progress>
          </div>
        </div>

        <div class="content">
          <ValidationObserver ref="form1" v-slot="{ invalid, errors }">
            <div v-if="invalid"> {{ disableSave(true, errors)}} </div>
            <div v-else> {{ disableSave()}} </div>
            <form @submit.prevent="invalid" autocomplete="off">

              <!-- Loan -->
              <scroll-section name="Loan" id="capture-section-loan">

                <!-- Owners -->
                <scroll-section name="Owners" id="capture-section-loan-owners">
                  <view-loan-owners v-model="application" />
                </scroll-section>

                <!-- Loan -->
                <scroll-section name="Details" id="capture-section-loan-details">
                  <edit-loan-details v-model="application" />
                </scroll-section>

              </scroll-section>

              <md-tabs @md-changed="applicant_index = $event" class="section-tabs">
                <md-tab v-for="({applicant}, index) in applicants" :key="index"
                :id="String(index)"
                :md-label="'Applicant '+(index+1)">

                  <!-- Applicant -->
                  <scroll-section :name="'Applicant '+(index+1)" :id="'applicant-'+index+'-capture-section-applicant'"
                  :show="applicant_index == index">

                    <edit-applicant
                      :value="applicant"
                      :index="index"
                      :shown="applicant_index == index"
                      :application="application"
                      :prefixLabel="'Applicant ' + (index+1)"
                      v-on:application-change="setApplication()"
                    />

                  </scroll-section>
                </md-tab>
              </md-tabs>

              <!-- Go To Assessment Page button -->
              <div class="md-layout">
                <div class="md-layout-item gt-assessment">
                  <md-button class="md-primary md-sm" @click="onGoToAssessment">
                  <span>Go To Assessment</span>
                  <md-icon>arrow_forward</md-icon>
                  </md-button>
                </div>
              </div>

            </form>
          </ValidationObserver>
        </div>
      </div>
      <floating-comment-section
        v-model="application"
        :available-sections="availableSections()"
        :current-sections="currentSections()"
      />
    </scroll-tracker>

  </div>

  <div v-else-if="application_status.loading">
    <md-empty-state
      md-icon="hourglass_empty"
      md-label="Loading"
      md-description="Please wait whilst the application is loading"
      />
  </div>

  <div v-else>
    <md-empty-state
      md-icon="close"
      md-label="No Application selected"
      md-description="Go to the Dashboard and select an application."
      />
  </div>

</template>
<script>

import { mapGetters } from 'vuex';
import { GroupCard } from "@/components";

import filters from "@/components/utils/filters";
import transitions from "@/components/utils/transitions";

import ScrollTracker from "@/components/ScrollTracker/ScrollTracker.vue";
import ScrollSection from "@/components/ScrollTracker/ScrollSection.vue";
import ScrollProgress from "@/components/ScrollTracker/ScrollProgress.vue";

import ButtonGroupInput from "@/components/ValidatedInput/ButtonGroupInput.vue";
import Editors from '@/components/Editors';
import EditApplicant from '@/components/Editors/EditApplicant';
import FloatingCommentSection from "@/components/Editors/FloatingCommentSection";
import DataDisplays from '@/components/DataDisplays';
import WaitingDialog from "../components/Dialogs/WaitingDialog";
import VueScrollTo from "vue-scrollto";

export default {
  mounted() {
    this.wizardModel = this.$store.state.selected_application;
    if (location.hash != '' && location.hash != null ) {
      setTimeout(() => {
            this.$scrollTo(location.hash, {container: ".scroll-area"})
          }, 100)
    } else {
      setTimeout(() => {
            this.$scrollTo('#document-top', {container: ".scroll-area"})
          }, 100)
    }
  },
  components: {
    GroupCard,

    ScrollTracker,
    ScrollSection,
    ScrollProgress,

    ButtonGroupInput,
    EditApplicant,
    FloatingCommentSection,
    ...Editors,
    ...DataDisplays,
    WaitingDialog,
  },
  data() {
    return {
      applicant_index: 0,
      selected_veda_details: '',
      comment_section_vissible: false,
      transitions,
      saving_status: 'unsaved',
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      confirm_dialog: {
        show: false,
        title: '',
        content: '',
        value: false,
        action: () => {}
      },
      snackbar: {
        show: false,
        icon: 'done',
        content: '',
      },
      activeTimeouts: [],
    };
  },
  computed: {
    ...mapGetters([
      'application',
      'application_status',
      'error_fields',
      'appLockConfig',
      'userHasPermission',
      "current_lock",
    ]),
    applicants(){
      if (this.application.applicants.length > 0) {
        return this.application.applicants.map(applicant => {return {applicant};});
      }
    },
    canLock() {
      return !this.userHasPermission('bypass-application-lock') && this.$route.params.id !== 'new'
    }
  },
  watch: {
    "application_status.locked" (isLocked) {
      // If is not locked do nothing.
      if (this.canLock && !isLocked) {
        return
      }

      // if isLocked (lock has expired) show notification and push to workbasket and save
      this.saveApplication()
      this.$router.push('./basket')
      this.$notifications.notify({
        'message': 'Application lock has been released.',
        'icon': 'lock',
        'timeout': 5000,
        'verticalAlign': 'top',
        'horizontalAlign': 'center'
      })
    },
    async $route (to, from) {
      if (!this.userHasPermission('bypass-application-lock')) {
        await this.$store.dispatch('release_application_lock', from.params.id);
        await this.$store.dispatch('lock_application', to.params.id);
      }
    }
  },
  beforeDestroy() {
    this.releaseLock();
  },
  methods: {
    ...filters,
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    availableSections(){
      let section_names = [];
      if (this.$refs['scroll-tracker']) {
        let sections = this.$refs['scroll-tracker'].sections;
        section_names = sections.map(section => {
          let name = section.name;
          let parent = section.parent;
          while (parent) {
            name = `${parent.name} - ${name}`;
            parent = parent.parent;
          }
          return name;
        });
      }
      section_names.push("Wallet Notification");
      return section_names;
    },
    currentSections(){
      let current_sections = '';
      if (this.$refs['scroll-tracker']) {
        let sections = this.$refs['scroll-tracker'].sections;
        let deepest_section_path = [];

        for (let section of sections) {

          if (!section.visible) {
            continue;
          }

          let path = [section];
          let parent = section.parent

          while (parent) {
            path.unshift(parent);
            parent = parent.parent;
          }

          if (path.length > deepest_section_path.length) {
            deepest_section_path = path;
          }
        }

        current_sections = deepest_section_path.map(s => s.name).join(' - ');
      }
      return current_sections;
    },
    wizardComplete() {
      Swal.fire({
        title: "Good job!",
        text: "You clicked the finish button!",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    },
    async saveApplication(){
      this.saving_status = 'saving';
      try {
        let result = await this.$store.dispatch('save_application', this.application);
        this.saving_status = 'saved';

        if (result === true) {
          this.snackbar.content = 'Application saved successfully';
          this.snackbar.icon = 'done';
          this.snackbar.show = true;
        }
      } catch (error) {
        this.showNotification('Failed to save Application', `The following error occurred: ${error.reponse.data}`);
      }
    },
    setApplication(){
      this.$modal.show(WaitingDialog, {
        title: 'Processing...',
        message: 'Please wait whilst we are fetching the application.',
      });
      let application = this.$store.getters.getApplication();
      // this.application = application;
      // this.applicant = this.application.applicants[0];
    },
    onGoToSummary(){
      this.$router.push('/application/summary');
    },
    showNotification(title, message){
      this.error_dialog.title = title;
      this.error_dialog.content = message;
      this.error_dialog.show = true;
    },
    disableSave(isDisabled = false, errors = {}) {
      let error_fields = [];
      if (isDisabled) {
        Object.entries(errors).forEach(([key, value]) => {
          if (value.length > 0) {
            error_fields.push(key);
          }
        });
        Vue.set(this.$store.state.application_status, 'disable_save', true);
      } else {
        Vue.set(this.$store.state.application_status, 'disable_save', false);
      }
      Vue.set(this.$store.state, 'error_fields', error_fields);
    },
    async onGoToAssessment() {
      //show the popup
      this.$modal.show(WaitingDialog, {
        title: 'Processing...',
        message: 'Taking you to assessment page once the application is saved.',
      });
      if (!this.application_status.disable_save) {
        try {
          //save the application
          let saved = await this.$store.dispatch('save_application', this.application);
          //once save_application is complete, check the visibility of modal and close it if its open
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          if (saved) {
            //set url id if new application
            this.$store.commit('redirect_after_save', this.application);
            //route to assessment page
            this.$router.push('./assessment');
          }
        } catch (error) {
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          this.showNotification('Failed to save Application', `The following error occurred: ${error.response.data}`);
        }
      } else {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
        this.showNotification('Failed to save Application', filters.getErrorFieldsMessage(this.error_fields));
      }
    },
    confirmSendDriveWholesaleDialog() {
      this.showConfirm(
        "DriveWholesale",
        "Confirm sending the loan application data for DriveWholesale Feature?",
        () => this.sendDriveWholesaleRequest());

    },
    async sendDriveWholesaleRequest() {
      return await axios.post(
        "/api/v1/application/send_drivewholesale_request",
        {
          application_id: this.application.loan.id,
        })
    },
    showConfirm(title, message, action) {
      this.confirm_dialog.title = title;
      this.confirm_dialog.content = message;
      this.confirm_dialog.show = true;
      this.confirm_dialog.action = action
    },
    onConfirm () {
      this.confirm_dialog.value = true
    },
    onCancel () {
      this.confirm_dialog.value = false
    },
    confirmLock() {
      this.showConfirm(
        "Extend Application Lock",
        "Your application lock is about to expire within a minute. Do you want to extend it?",
        () => this.onConfirm());
      this.activeTimeouts.push(
          setTimeout(async function (vue) {
          if (!vue.confirm_dialog.value) {
            vue.$store.commit("setApplicationStatus", {
              locked: true
            })
          } else {
            if (!await vue.lockApplication()) {
              vue.$store.commit("setApplicationStatus", {
                locked: true
              })
            } else {
              vue.activeTimeouts.push(setTimeout(vue.confirmLock, 1000 * 60 * (vue.appLockConfig.duration - vue.appLockConfig.reminder)));
            }
          }
          vue.confirm_dialog.value = false
        }, 1000 * 60 * this.appLockConfig.reminder, this)
      )
    },
    lockApplication() {
      return this.$store.dispatch('lock_application', this.$route.params.id);
    },
    releaseLock() {
      //Remove listener when lock got release
      this.removeBeforeUnload();
      if (!this.canLock) {
        return
      }
      // Remove lock
      this.$store.dispatch('release_application_lock', this.$route.params.id).catch((error) => console.log(error))
      // Clear all timeouts current running by id
      this.activeTimeouts.forEach((val) => {
        clearTimeout(val)
      })
    },
    removeBeforeUnload() {
      window.removeEventListener("beforeunload", () => {
        this.releaseLock();
      });
    }
  },
  filters: {
    ...filters,
  },
  async created(){
    window.addEventListener("beforeunload", () => {
      this.releaseLock();
    });

    if (this.userHasPermission('bypass-application-lock') === false && this.$route.params.id !== 'new') {
      if (!await this.lockApplication()) {
        this.$notifications.notify({
          'message': this.current_lock.messages,
          'icon': 'lock',
          'timeout': 5000,
          'verticalAlign': 'top',
          'horizontalAlign': 'center'
        })
      } else {
        this.activeTimeouts.push(setTimeout(this.confirmLock, 1000 * 60 * (this.appLockConfig.duration - this.appLockConfig.reminder)));
      }
    }
    this.setApplication();
    if (this.$modal.submit) {
      this.$modal.submit();
    }
  },
}
</script>

<style scoped lang="scss">
  @import "@/assets/scss/theme.scss";
  @import "@/assets/scss/md-custom/_ausloans-colors.scss";

  .md-layout-item.md-size-66 {
    min-width: 66.6666%;
    max-width: 100%;
    flex: 0 1 100%;
  }

  .applicant-selector{
    background: #EEEEEE;
    outline: 3px solid #EEEEEE;
    z-index: 2;
  }

  .navigation{
    width: 165px;

    & h4{
      padding: 12px 0px;
    }
  }

  .content{
    position: relative;
    width: calc(100% - 200px);
  }

  .btn-selected{
    border-bottom: 4px solid $color-primary;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .list-item{
    margin-bottom: 25px;
    padding-top: 15px;
    padding-bottom: 15px;

    background: rgba(0,0,0,0.03);
    border-radius: 3px;
    box-shadow: 0px 0px 4px 1px rgba(0,0,0,0.2);
  }

  .floating-bottom-right{
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 3;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;

    & button.fab{
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }

  }

  .section-tabs{

    margin-top: 25px;

    &::v-deep .md-tabs-navigation{
      position: sticky;
      top: 0px;
      z-index: 2;
      background: $grey-200 !important;

      & .md-active {
        background-color: $ausloans-blue-dark !important;
        color: white !important;
      }

    }

    &::v-deep .md-tabs-content{
      background: transparent !important;

      & .md-tab{
        padding-left: 0px;
        padding-right: 0px;
      }

    }

  }
  .sticky-top {
    margin-left: -15px;
    padding-left: 15px;
    background-color: $ausloans-sidebar-grey;
    height: 100vh;
    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 50%);
  }
</style>
